export default __webpack_public_path__ + "static/media/internationalBG.6b0d5955.jpg";